import { render, staticRenderFns } from "./CadastroFederalInput.vue?vue&type=template&id=0697b1db&"
import script from "./CadastroFederalInput.vue?vue&type=script&lang=js&"
export * from "./CadastroFederalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports